import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useTranslation } from 'src/i18n';
import CountVerdictTable from '../Commissioning/CountVerdictTable';
import NotesField from '../Commissioning/NotesField';

// Section 4: panel inspection summary and its recommendations. The first two rows ask a
// question with no count, so they share the table with a blank count cell.
const ROWS = [
  { key: 'powerPanelDeficiencies', hasCount: false },
  { key: 'controlPanelDeficiencies', hasCount: false },
  { key: 'branchCircuits', hasCount: true, questionKey: 'matchAsBuilt' },
  { key: 'openBranchCircuits', hasCount: true, questionKey: 'investigatedInField' },
  { key: 'shortBranchCircuits', hasCount: true, questionKey: 'investigatedInField' },
  { key: 'controllerAlarms', hasCount: true, questionKey: 'investigatedInField' },
  { key: 'controllerWarnings', hasCount: true, questionKey: 'investigatedInField' },
];

export default function HmsAuditPanelInspection (props) {
  const { data, onChange, readOnly } = props;
  const { t } = useTranslation();
  const panel = data?.get('panelInspection');

  const rows = useMemo(() => ROWS.map(row => ({
    ...row,
    label: t(`hmsAudit.panel.${row.key}`),
    question: row.questionKey ? t(`hmsAudit.${row.questionKey}`) : '',
  })), [t]);

  return (
    <div>
      <CountVerdictTable
        title={t('hmsAudit.panelInspectionSummary')}
        labelHeader={t('hmsAudit.table.circuitCounts')}
        rows={rows}
        data={panel}
        extrasPath={['extras', 'panelInspection']}
        onChange={onChange}
        readOnly={readOnly}
      />

      <NotesField
        title={t('hmsAudit.recommendations')}
        value={panel?.get('recommendations')}
        path={['extras', 'panelInspection', 'recommendations']}
        onChange={onChange}
        readOnly={readOnly}
      />
    </div>
  );
}

HmsAuditPanelInspection.propTypes = {
  data: ImmutablePropTypes.map,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

HmsAuditPanelInspection.defaultProps = {
  readOnly: false,
};
